
import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';

import Tag from '@/components/common/tag/tag'
import YellowTimer from '@/assets/icons/yellowTimer.png'
import PinkFilledHeart from '@/assets/icons/pinkFilledHeart.png'
import GreyInfo from '@/assets/icons/greyInfo.png'
import GreenTick from '@/assets/icons/greenTick.png'



import './style.css';
import { useEffect, useState } from 'react';
import { allSeriesCompleted } from '@/utils';
import moment from 'moment';

export default function CourseCard() {
    const { timeline, common } = useLocalTranslation();
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const screenWidth = useSelector((state: RootState) => state.screenWidthReducer.screenWidth);

    const underProgressSeriesCompletedTagDetails = {
        text: timeline.underProgress,
        icon: YellowTimer,
        colorCode: "yellow",
        iconWidth:"12px"
    }

    let completedSeriesCompletedTagDetails: any = {
        text: common.statusText.completedOn,
        icon: GreenTick,
        colorCode: "green",
        iconWidth:"15px"
    }

    const [seriesCompletedTagDetails, setSeriesCompletedTagDetails] = useState(underProgressSeriesCompletedTagDetails)

    const imageSrc = screenWidth > 1200
        ? timelineDetails?.rectangleThumbnailUrl
        : timelineDetails?.squareThumbnailUrl;

    useEffect(() => {
        handleSeriesCompleted()
    }, [timelineDetails])


    const handleSeriesCompleted = () => {
        const seriesCompletedOn_ = allSeriesCompleted(timelineDetails.series)
        // const seriesCompletedOn_ = "2025-08-04T09:33:21.310+00:00" // testing
        if (seriesCompletedOn_) {
            completedSeriesCompletedTagDetails.text = common.statusText.completedOn + " " + moment(seriesCompletedOn_).format('DD MMM, YYYY')
            setSeriesCompletedTagDetails(completedSeriesCompletedTagDetails)
            // console.log(completedSeriesCompletedTagDetails)
        }
    }

    return (
        <>
            {Object.entries(timelineDetails).length > 0 &&
                <div>
                    <div className='flex justify-between'>
                        <h1 className='text-[18px] mb-[18px] font-medium'>{timeline.courseCardHeading}</h1>
                        <img
                            className='cursor-pointer w-[20px] h-[20px]' src={GreyInfo} alt='GreyInfo' />
                    </div>

                    <div className='courseCardInteralComponent1'>
                        <img className='courseCard' src={imageSrc} alt="course card" />

                        <div className='courseCardInteralComponent2'>
                            <h1 className='courseHeading text-[16px]'>{timelineDetails?.title}</h1>
                            <div className='flex gap-2'>
                                <div className='w-fit'>
                                    <Tag
                                        text={seriesCompletedTagDetails.text}
                                        icon={seriesCompletedTagDetails.icon}
                                        colorCode={seriesCompletedTagDetails.colorCode}
                                        iconWidth={seriesCompletedTagDetails.iconWidth}
                                        borderR_tl="5px"
                                        borderR_tr="5px"
                                        borderR_bl="5px"
                                        borderR_br="5px"
                                        borderWidth="0.5px"
                                        textSize="12px"
                                        padding_left="10px"
                                        padding_top="6px"
                                        padding_right="10px"
                                        padding_bottom="7px"
                                        line_hight="17px"
                                    />
                                </div>

                                {timelineDetails.courseType && timelineDetails.courseType === "free" &&
                                    <div className='w-fit'>
                                        <Tag
                                            text={timeline.freeAccess}
                                            icon={PinkFilledHeart}
                                            colorCode="pink"
                                            borderR_tl="5px"
                                            borderR_tr="5px"
                                            borderR_bl="5px"
                                            borderR_br="5px"
                                            iconWidth="17px"
                                            borderWidth="0.5px"
                                            textSize="12px"
                                            padding_left="10px"
                                            padding_top="7px"
                                            padding_right="10px"
                                            padding_bottom="7px"
                                            line_hight="17px"
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>


                </div>
            }

        </>
    );
}
